import { TpDashboardCreationContext } from '../../dashboard/interfaces';
import { jsonReplaceDbActionVariables } from '../helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Add Section Element',
    description:
      'Creates a new chart widget on the dashboard. This widget is temporary for the user session and will not be permanently saved.',
    properties: {
      type: { type: 'string', const: 'AddSectionElement' },
      targetSectionId: {
        type: 'string',
        description: 'Identifier of the section in the dashboard where this widget should be added to.',
      },
      definition: {
        type: 'object',
        description:
          'Definition of the Section Element to be displayed. See /elements/sections/elements for more information. Note that this definition can refer to variables created earlier via "$VariableName".',
      },
    },
    required: ['type', 'targetSectionId', 'definition'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const elemDef = jsonReplaceDbActionVariables(ctx, step.definition);

  const elemCtx: TpDashboardCreationContext = {
    dataContext: ctx.dataContext,
    contextVariables: {},
  };

  ctx.dashboardContext.addElementToSection(elemDef, ctx.dashboardContext.dashboardDefId, step.targetSectionId, elemCtx);

  onCompleted();
}

const dbActionStepTypeAddSectionElement: TpDbActionStepTypeDefinition = {
  stepType: 'AddSectionElement',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeAddSectionElement;
